export const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
  
    const base64 = new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
    });
  
    return base64;
  };